import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'
import { ordersApi } from '@/lib/store/api/referral/ordersApi'
import type {
  ReferralPreference,
  ReferralPreferenceUpdateRequest,
} from './types'

export const preferenceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReferralOrderPreference: builder.query<ReferralPreference, { orderId: string }>({
      query: ({ orderId }) => apiEndpoints.referralOrders.preference(orderId),
      providesTags: (_result, _error, { orderId }) => [
        { type: 'ReferralOrderPreference', id: orderId },
      ],
    }),

    updateReferralOrderPreference: builder.mutation<
      ReferralPreference,
      { orderId: string } & ReferralPreferenceUpdateRequest
    >({
      query: ({ orderId, ...body }) => ({
        url: apiEndpoints.referralOrders.preference(orderId),
        method: 'PATCH',
        body,
      }),
      async onQueryStarted({ orderId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedPreference } = await queryFulfilled

          dispatch(preferenceApi.util.updateQueryData('getReferralOrderPreference', { orderId }, (draft) => {
            Object.assign(draft, updatedPreference)
          }))
          dispatch(ordersApi.util.updateQueryData('getReferralOrder', { orderId }, (draft) => {
            if (!draft.booking) return
            draft.booking.preference = updatedPreference
          }))
        } catch {
          // Leave caches unchanged when the PATCH fails.
        }
      },
      invalidatesTags: (_result, _error, { orderId }) => [
        { type: 'ReferralOrderPreference', id: orderId },
        { type: 'ReferralOrder', id: orderId },
      ],
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetReferralOrderPreferenceQuery,
  useUpdateReferralOrderPreferenceMutation,
} = preferenceApi
